export default __webpack_public_path__ + "scripts/resource/b135204864868bff532d57fd3a9caa40.svg";